<template>
  <v-card>
    <v-card-text>
      <div>
        <v-icon small color="primary">lens</v-icon> Given energy
      </div>
      <div>
        <v-icon small color="secondary">lens</v-icon> Received energy
      </div>
      <div>
        <a href="https://www.icabody.com/interpretation" target="_blank">Read more</a>
      </div>
      <div class="color-primary bold">CLICK ON IMAGE TO DOWNLOAD</div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'ChartLegend',

  data() {
    return {
      debug: false,
    }
  },

  props: {},

  watch: {},

  computed: {},

  methods: {}
}
</script>

<style scoped>  /* "scoped" attribute limit the CSS to this component only */
</style>